import { useHistory, useLocation } from "react-router-dom";
import * as Styles from "./Close.styles";
import { Switch, Checkbox, message, Select } from "antd"; // Add message for notifications
import { PiWarningCircle } from "react-icons/pi";
import { FaAngleDown, FaAngleUp, FaChevronDown } from "react-icons/fa6";
import { useState, useMemo, use, useEffect } from "react";
import countryList from "react-select-country-list";
import { getCountryCode, getName } from "country-flag-icons";
// Import payment services
import {
  processStripePayment,
  createUserInfo,
  recordConversion,
  getPaymentAmount,
  formatStripePaymentData,
  formatConversionData,
  updateUserInfo,
  joinChallenge,
} from "services/paymentService";
import CoachImage from "assets/images/health-analyse/felix.png";
import PaymentMethods from "assets/images/health-analyse/payment-methods.png";
import { PASSWORT } from "routes/routes";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ApiCollections from "configs/services/apiCollections";
import * as CoachActions from "redux/coach/coach.actions";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";
import moment from "moment";

function Close() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { trainerShowData, registrationData } = useSelector(
    (state) => state.auth
  );

  const userAllData = useSelector((state) => state.auth);
  const [ipAddress, setIpAddress] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const userPlan = queryParams.get("user") || "pro";
  const refundAmount = queryParams.get("refund") || "0,00";
  const fullPrice =
    queryParams.get("fullPrice") || (userPlan === "pro" ? 450 : 150);
  const refundValue = parseFloat(refundAmount.replace(",", ".")) || 0;
  const [paymentFrequency, setPaymentFrequency] = useState("monatlich");
  const [products, setProducts] = useState([]);
  const [street, setStreet] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipCode] = useState("");
  const [country, setCountry] = useState({ value: "DE", label: "Deutschland" });
  const [startDirectly, setStartDirectly] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [loading, setLoading] = useState(false);

  // Add form validation state
  const [errors, setErrors] = useState({
    street: false,
    houseNumber: false,
    city: false,
    zipcode: false,
    country: false,
  });

  useEffect(() => {
    const data = {
      trainer_id: registrationData?.trainerID,
    };
    ApiCollections.getProductsjp(data)
      .then((res) => {
        setProducts(res.getAllProductsJpByTrainerId);
      })
      .catch((err) => {
        console.log("🚀 ~ err:", err);
      });
  }, []);

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "street":
        setStreet(value);
        // Clear error when user types
        if (value) setErrors((prev) => ({ ...prev, street: false }));
        break;
      case "houseNumber":
        setHouseNumber(value);
        if (value) setErrors((prev) => ({ ...prev, houseNumber: false }));
        break;
      case "city":
        setCity(value);
        if (value) setErrors((prev) => ({ ...prev, city: false }));
        break;
      case "zipcode":
        setZipCode(value);
        if (value) setErrors((prev) => ({ ...prev, zipcode: false }));
        break;
      default:
        break;
    }
  };

  const handlePaymentToggle = (checked) => {
    setPaymentFrequency(checked ? "monatlich" : "einmalig");
  };
  const handleBtnClick = async () => {
    // Validate all required fields
    const newErrors = {
      street: !street,
      houseNumber: !houseNumber,
      city: !city,
      zipcode: !zipcode,
      country: !country,
    };

    setErrors(newErrors);

    if (!street || !zipcode || !houseNumber || !city || !country) {
      message.error("Bitte fülle alle Pflichtfelder aus.");
      return;
    }

    if (!agreeToTerms) {
      message.error("Bitte akzeptiere die AGB und Datenschutzbestimmungen.");
      return;
    }

    setLoading(true);

    try {
      const userId = registrationData?.userID;
      const token = registrationData.token;
      const trainerId = registrationData?.trainerID;

      // Calculate payment amount
      const amount = getPaymentAmount(userPlan, paymentFrequency);

      // Prepare data for APIs
      const updateUserData = {
        userID: userId,
        street: street,
        city: city,
        zipcode: zipcode,
        country: country.label || "Deutschland",
        housenumber: houseNumber,
      };

      const paymentData = formatStripePaymentData(
        userId,
        trainerId,
        userPlan,
        paymentFrequency,
        amount
      );

      const userData = {
        firstName: registrationData?.prename,
        lastName: registrationData?.surname,
        street,
        postalCode: zipcode,
      };

      const conversionData = formatConversionData(
        registrationData?.email,
        userId,
        parseInt(fullPrice),
        userPlan,
        userData,
        trainerShowData?.prename + " " + trainerShowData?.surname,
        trainerShowData?.email,
        trainerShowData?.FranchiseID,
        ipAddress
      );

      // 1. Update user information (non-blocking)
      updateUserInfo(updateUserData, token)
        .then(() => {
          console.log("User information updated successfully");
        })
        .catch((error) => {
          console.error("Failed to update user information:", error);
          // Don't show error to user - this is non-critical
        });

      // 2. Process Stripe payment - CRITICAL STEP
      const paymentResponse = await processStripePayment(paymentData, token);
      console.log("Payment processed successfully:", paymentResponse);

      // Payment successful - immediately navigate and show success
      message.success("Deine Bestellung wurde erfolgreich abgeschlossen!");
      setLoading(false);
      history.push(PASSWORT);

      // 3. Continue with background APIs (non-blocking) - these run after navigation
      createUserInfo({ user_id: userId }, token)
        .then((userApiResponse) => {
          console.log("User info created successfully");
        })
        .catch((error) => {
          console.error("Failed to create user info:", error);
          // Don't show error to user - component may be unmounted
        });

      // Join challenge
      const challengeObj = {
        user_id: registrationData?.userID,
        start_date: moment().format("YYYY-MM-DD"),
        completed_at: null,
        is_winner: false,
      };
      joinChallenge(challengeObj).catch((error) => {
        console.log("🚀 ~ handleBtnClick ~ joinChallenge error:", error);
      });

      // Send email if business model ID is 3
      if (trainerShowData?.businessModelId == 3) {
        const emailBody = {
          template_name: "neue-health-analyse-closing-foodiary-coach-id3",
          template_content: [
            {
              name: "prename",
              content: registrationData?.prename,
            },
            {
              name: "prenameCoach",
              content: trainerShowData.prename,
            },
            {
              name: "product_obst",
              content: products[0]?.product_jp_shoppingcart,
            },
            {
              name: "product_beeren",
              content: products[1]?.product_jp_shoppingcart,
            },
            {
              name: "product_omega",
              content: products[2]?.product_jp_shoppingcart,
            },
          ],
          subject: "Verbessere jetzt deine Gesundheit",
          from_email: "backoffice@foodiary.app",
          to: [
            {
              email: registrationData?.email,
              type: "to",
            },
            {
              email: "spam@foodiary.app",
              type: "bcc",
            },
          ],
        };

        dispatch(
          CoachActions.sendTransactionalEmail({
            body: emailBody,
            callback: (res) => {
              console.log("🚀 ~ handleBtnClick ~ email sent:", res);
            },
          })
        );
      }

      // Record conversion
      recordConversion(conversionData, token)
        .then(() => {
          console.log("Conversion recorded successfully");
        })
        .catch((error) => {
          console.error("Failed to record conversion:", error);
        });
    } catch (error) {
      // Only payment errors should reach here
      console.error("Payment process error:", error);
      message.error(
        "Es gab ein Problem bei der Verarbeitung deiner Zahlung. Bitte versuche es erneut."
      );
      setLoading(false);
    }
  };

  // Calculate prices based on plan type and payment frequency
  const getPriceDetails = () => {
    // Helper function to properly format refund amount
    const formatRefund = (value) => {
      // If already contains comma, it's already formatted
      if (typeof value === "string" && value.includes(",")) {
        return value;
      }
      // Otherwise format as German currency (150 -> "150,00")
      return parseFloat(value).toFixed(2).replace(".", ",");
    };

    if (userPlan === "plus") {
      // PLUS plan pricing
      if (paymentFrequency === "monatlich") {
        return {
          planName: "Coaching PLUS",
          basePrice: "50,00", // Monthly price
          totalBase: 150, // Total base price for calculation
          refund: formatRefund(refundAmount),
          total: Math.max(0, 150 - refundValue)
            .toFixed(2)
            .replace(".", ","),
        };
      } else {
        // Same logic with formatRefund for einmalig
        return {
          planName: "Coaching PLUS",
          basePrice: "150,00",
          totalBase: 150,
          refund: formatRefund(refundAmount),
          total: Math.max(0, 150 - refundValue)
            .toFixed(2)
            .replace(".", ","),
        };
      }
    } else {
      // PRO plan pricing - same pattern with formatRefund
      if (paymentFrequency === "monatlich") {
        return {
          planName: "Foodiary Coaching PRO",
          basePrice: "150,00",
          totalBase: 450,
          refund: formatRefund(refundAmount),
          total: Math.max(0, 450 - refundValue)
            .toFixed(2)
            .replace(".", ","),
        };
      } else {
        return {
          planName: "Foodiary Coaching PRO",
          basePrice: "450,00",
          totalBase: 450,
          refund: formatRefund(refundAmount),
          total: Math.max(0, 450 - refundValue)
            .toFixed(2)
            .replace(".", ","),
        };
      }
    }
  };

  const priceDetails = getPriceDetails();

  // Setup country options with flags
  const countryOptions = useMemo(() => {
    const options = countryList().getData();

    // Common European countries to show first
    const priorityCountries = [
      "DE",
      "AT",
      "CH",
      "NL",
      "BE",
      "LU",
      "FR",
      "IT",
      "ES",
    ];

    // Filter and sort countries to prioritize European ones
    const sortedOptions = options
      .map((country) => ({
        value: country.label,
        label: country.label,
        flag: country.value,
      }))
      .sort((a, b) => {
        const aIndex = priorityCountries.indexOf(a.value);
        const bIndex = priorityCountries.indexOf(b.value);

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return a.label.localeCompare(b.label);
      });

    return sortedOptions;
  }, []);

  // Custom option and value components for Select to show flags
  const formatOptionLabel = ({ label, value }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span className="flag-icon">{value && getFlagEmoji(value)}</span>
      <span>{label}</span>
    </div>
  );

  // Convert country code to flag emoji
  const getFlagEmoji = (countryCode) => {
    const codePoints = countryCode
      .toUpperCase()
      .split("")
      .map((char) => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  };

  const handleCountryChange = (selectedOption) => {
    setCountry(selectedOption);
    setErrors((prev) => ({ ...prev, country: false }));
  };

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Start"}
          subHeadline={"Gemeinsam gesunde Gewohnheiten aufbauen."}
          handleNextPage={handleBtnClick}
          btnText="Kostenpflichtig abschließen"
          noBackButton={true}
          loading={loading}
        />
        {/* Mobile View */}
        <Styles.MobileView>
          <div className="main-div">
            <Styles.ContentSection>
              <Styles.ProfileGoalSection>
                <img
                  src={IMG_BASE_URL + trainerShowData?.profilePic}
                  alt="Coach"
                />
                <div className="goal-info">
                  <div className="goal-label">Dein Ziel:</div>
                  <h3 className="goal-value">Abnehmen</h3>
                  <div className="goal-description">
                    Ich unterstütze dich dabei, dass du in wenigen Wochen dein
                    Ziel erreichst.
                  </div>
                </div>
              </Styles.ProfileGoalSection>
              <Styles.Divider />

              <Styles.PaymentToggleDesktop margin={"10px 0px 0px 0px"}>
                <span
                  style={{
                    color:
                      paymentFrequency != "monatlich" ? "#2ecf96" : "#A5B5AF",
                  }}
                >
                  Monatlich
                </span>
                <Switch
                  checked={paymentFrequency === "monatlich"}
                  onChange={handlePaymentToggle}
                  className="payment-switch-desktop"
                />
                <span
                  style={{
                    color:
                      paymentFrequency == "monatlich" ? "#2ecf96" : "#A5B5AF",
                  }}
                >
                  Einmalig
                </span>
              </Styles.PaymentToggleDesktop>

              <Styles.PaymentBreakdown>
                <div className="payment-item">
                  <div className="payment-info">
                    <h3 className="payment-title">{priceDetails.planName}</h3>
                    <p className="payment-subtitle">
                      {paymentFrequency === "monatlich"
                        ? "Monatlich"
                        : "Einmalig"}
                    </p>
                  </div>
                  <Styles.HeaderWrapper>
                    <p className="payment-amount">{priceDetails.basePrice} €</p>
                  </Styles.HeaderWrapper>
                </div>

                <div className="payment-item">
                  <div className="payment-info">
                    <h3 className="payment-title">Deine Krankenkasse</h3>
                    <p className="payment-subtitle primary">Erstattung</p>
                  </div>
                  <Styles.HeaderWrapper>
                    <p className="payment-amount primary ">
                      {priceDetails.refund} €
                    </p>
                  </Styles.HeaderWrapper>
                </div>

                <div className="payment-item">
                  <div className="payment-info">
                    <h3 className="payment-title">Eigenanteil</h3>
                    <p className="payment-subtitle">Inkl. MwSt.</p>
                  </div>
                  <Styles.HeaderWrapper>
                    <h3 className="payment-amount">{priceDetails.total} €</h3>
                  </Styles.HeaderWrapper>
                </div>
              </Styles.PaymentBreakdown>

              <Styles.PaymentMethods>
                <div className="payment-methods">
                  <img src={PaymentMethods} alt="Payment Methods" />
                </div>
                <p className="payment-info-text">
                  Unkompliziert starten & per Rechnung bezahlen.
                </p>
              </Styles.PaymentMethods>

              <Styles.RegistrationForm>
                <h3 className="form-section-title">
                  Starte jetzt, sichere dir deinen Coach.
                </h3>
                <Styles.Row>
                  <PiWarningCircle className="mt-1" />
                  <div className="form-description">
                    Deine Kosten werden von der Krankenkasse erstattet
                  </div>
                </Styles.Row>
                <Styles.FormGroup>
                  <label>Straße</label>
                  <Styles.Input
                    name="street"
                    type="text"
                    value={street}
                    onChange={handleInputChange}
                    hasError={errors.street}
                  />
                </Styles.FormGroup>
                <Styles.FormGroup>
                  <label>Hausnummer</label>
                  <Styles.Input
                    name="houseNumber"
                    type="text"
                    value={houseNumber}
                    onChange={handleInputChange}
                    hasError={errors.houseNumber}
                  />
                </Styles.FormGroup>
                <Styles.FormGroup>
                  <label>Postleitzahl</label>
                  <Styles.Input
                    name="zipcode"
                    type="text"
                    value={zipcode}
                    onChange={handleInputChange}
                    hasError={errors.zipcode}
                  />
                </Styles.FormGroup>
                <Styles.FormGroup>
                  <label>Ort</label>
                  <Styles.Input
                    name="city"
                    type="text"
                    value={city}
                    onChange={handleInputChange}
                    hasError={errors.city}
                  />
                </Styles.FormGroup>
                <Styles.FormGroup>
                  <label>Land</label>
                  <Styles.CountrySelectWrapper hasError={errors.country}>
                    <Select
                      style={{ width: "100%", height: "45px" }}
                      options={countryOptions}
                      value={country}
                      onChange={handleCountryChange}
                      className="country-select"
                      classNamePrefix="country-select"
                      placeholder="Land auswählen"
                      suffixIcon={<FaChevronDown />}
                    />
                  </Styles.CountrySelectWrapper>
                </Styles.FormGroup>

                {/* <Styles.FormGroup>
                <label>Passwort festlegen:*</label>
                <Styles.Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="• • • • • • • • • •"
                />
              </Styles.FormGroup>

              <Styles.FormGroup>
                <label>Passwort bestätigen:*</label>
                <Styles.Input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="• • • • • • • • • •"
                />
              </Styles.FormGroup> */}

                <Styles.CheckboxGroup>
                  <Checkbox
                    checked={startDirectly}
                    onChange={(e) => setStartDirectly(e.target.checked)}
                    className="custom-checkbox"
                  >
                    Ich möchte mein Coaching direkt starten und die Leistung in
                    Anspruch nehmen.
                  </Checkbox>
                </Styles.CheckboxGroup>

                <Styles.CheckboxGroup>
                  <Checkbox
                    checked={agreeToTerms}
                    onChange={(e) => setAgreeToTerms(e.target.checked)}
                    className="custom-checkbox"
                  >
                    Ich stimme den{" "}
                    <Styles.LinkText
                      href="https://foodiary.app/terms/agb-coaching/"
                      target="_blank"
                    >
                      AGB Coaching
                    </Styles.LinkText>{" "}
                    und dem{" "}
                    <Styles.LinkText
                      href="https://foodiary.app/terms/datenschutz/"
                      target="_blank"
                    >
                      Datenschutz
                    </Styles.LinkText>{" "}
                    von Foodiary zu.
                  </Checkbox>
                </Styles.CheckboxGroup>
              </Styles.RegistrationForm>
            </Styles.ContentSection>
          </div>
        </Styles.MobileView>

        {/* Desktop View - Matching the image */}
        <Styles.DesktopView>
          <Styles.DesktopContainer>
            <Styles.DesktopHeader>
              <Styles.DesktopTitle>
                Wir starten deine Ernährungsumstellung!
              </Styles.DesktopTitle>
              <Styles.DesktopSubtitle>
                Wähle aus, wie du den Betrag für das persönliche Coaching
                begleichen möchtest.
              </Styles.DesktopSubtitle>
            </Styles.DesktopHeader>

            <Styles.PaymentToggleDesktop>
              <span
                style={{
                  color:
                    paymentFrequency === "monatlich" ? "#2ecf96" : "#A5B5AF",
                }}
              >
                Monatliche Zahlung
              </span>
              <Switch
                checked={paymentFrequency === "monatlich"}
                onChange={handlePaymentToggle}
                className="payment-switch-desktop"
              />
              <span
                style={{
                  color:
                    paymentFrequency === "einmalig" ? "#2ecf96" : "#A5B5AF",
                }}
              >
                Einmalige Zahlung
              </span>
            </Styles.PaymentToggleDesktop>

            <Styles.DesktopSubscriptionCard>
              <Styles.DesktopCardTitle>Abonnement</Styles.DesktopCardTitle>

              <Styles.SubscriptionItem>
                <Styles.SubscriptionLogo>
                  <div className={"pro-box"}>
                    {userPlan === "pro" ? "PRO" : "PLUS"}
                  </div>
                </Styles.SubscriptionLogo>
                <Styles.SubscriptionDetails>
                  <h3 className="subscription-name">{priceDetails.planName}</h3>
                  <p className="subscription-description">
                    Persönliche Ernährungsberatung
                  </p>
                  <p className="subscription-duration">3 Monate Laufzeit</p>
                </Styles.SubscriptionDetails>
                <Styles.SubscriptionPrice>
                  <div className="price">{priceDetails.basePrice} €</div>
                  <div className="frequency">
                    {paymentFrequency === "monatlich"
                      ? "monatlich"
                      : "einmalig"}
                  </div>
                </Styles.SubscriptionPrice>
              </Styles.SubscriptionItem>

              <Styles.SubscriptionItem>
                <Styles.SubscriptionLogo>
                  <div className="kre-box">KRE</div>
                </Styles.SubscriptionLogo>
                <Styles.SubscriptionDetails>
                  <h3 className="subscription-name">Deine Krankenkasse</h3>
                  <div className="subscription-description">
                    Einmalige Kostenrückerstattung
                  </div>
                  <div className="subscription-duration">Nach 8 Wochen</div>
                </Styles.SubscriptionDetails>
                <Styles.SubscriptionPriceHorizontol>
                  {/* <div className="price">
                  {priceDetails.totalBase.toFixed(2).replace(".", ",")} €
                </div> */}
                  <div className="price discount">{priceDetails.refund} €</div>
                </Styles.SubscriptionPriceHorizontol>
              </Styles.SubscriptionItem>
              <Styles.Divider />
              <Styles.TotalPrice>
                <Styles.DesktopCardTitle>Gesamt</Styles.DesktopCardTitle>
                <div>
                  <Styles.DesktopCardTitle color="#44554c">
                    {priceDetails.total} €
                  </Styles.DesktopCardTitle>
                  <div className="tax-note">inkl. MwSt.</div>
                </div>
              </Styles.TotalPrice>
            </Styles.DesktopSubscriptionCard>

            <Styles.DesktopAddressSection>
              <Styles.SectionDropdown>
                <h3 className="dropdown-header">Anschrift</h3>
              </Styles.SectionDropdown>
              <>
                <Styles.AddressFormRow>
                  <Styles.Row>
                    <Styles.AddressInput
                      name="street"
                      type="text"
                      placeholder="Straße"
                      value={street}
                      onChange={handleInputChange}
                      hasError={errors.street}
                    />
                    <Styles.AddressInput
                      name="houseNumber"
                      width={"20%"}
                      type="text"
                      placeholder="Hsnr"
                      value={houseNumber}
                      onChange={handleInputChange}
                      hasError={errors.houseNumber}
                    />
                  </Styles.Row>
                </Styles.AddressFormRow>

                <Styles.AddressFormRow>
                  <Styles.Row>
                    <Styles.AddressInput
                      name="zipcode"
                      width={"20%"}
                      type="text"
                      placeholder="Plz"
                      value={zipcode}
                      onChange={handleInputChange}
                      hasError={errors.zipcode}
                    />
                    <Styles.AddressInput
                      name="city"
                      type="text"
                      placeholder="Ort"
                      value={city}
                      onChange={handleInputChange}
                      hasError={errors.city}
                    />
                  </Styles.Row>
                </Styles.AddressFormRow>
                <Styles.AddressFormRow>
                  <Styles.CountrySelectWrapper hasError={errors.country}>
                    <Select
                      style={{ width: "100%", height: "45px" }}
                      options={countryOptions}
                      value={country}
                      onChange={handleCountryChange}
                      className="country-select"
                      classNamePrefix="country-select"
                      placeholder="Land auswählen"
                      suffixIcon={<FaChevronDown />}
                    />
                  </Styles.CountrySelectWrapper>
                </Styles.AddressFormRow>
              </>
            </Styles.DesktopAddressSection>

            <Styles.DesktopAgreementSection>
              <Styles.AgreementCheckbox>
                <Checkbox
                  checked={agreeToTerms}
                  onChange={(e) => setAgreeToTerms(e.target.checked)}
                  className="desktop-checkbox"
                />
                <div className="agreement-text">
                  Ich habe die{" "}
                  <Styles.LinkText
                    href="https://foodiary.app/terms/agb-coaching/"
                    target="_blank"
                  >
                    AGB Coaching
                  </Styles.LinkText>{" "}
                  und die{" "}
                  <Styles.LinkText
                    href="https://foodiary.app/terms/datenschutz/"
                    target="_blank"
                  >
                    Datenschutzbestimmungen
                  </Styles.LinkText>{" "}
                  gelesen, verstanden und akzeptiere diese.
                </div>
              </Styles.AgreementCheckbox>

              <Styles.AgreementCheckbox>
                <Checkbox
                  checked={startDirectly}
                  onChange={(e) => setStartDirectly(e.target.checked)}
                  className="desktop-checkbox"
                />
                <p className="agreement-text">
                  Ich stimme zu auf mein Widerruft zu verzichten, da sowohl der
                  Ernährungsplan als auch das Coaching speziell für mich
                  entwickelt wurden.
                </p>
              </Styles.AgreementCheckbox>
            </Styles.DesktopAgreementSection>
          </Styles.DesktopContainer>
        </Styles.DesktopView>
      </div>

      <button
        className="btn-dark w-full mt-8 btn-show"
        onClick={handleBtnClick}
        disabled={loading || !agreeToTerms}
      >
        {loading ? "Wird verarbeitet..." : "Jetzt kostenpflichtig starten"}
      </button>
    </Styles.Container>
  );
}

export default Close;
